import '../scss/style.scss';

import { openingFunc } from './modules/OpeningFunc';
import { popup } from './modules/Popup';
import { drawer } from './modules/Drawer';
import { smoothScroll } from './modules/SmoothScroll';
import { gnavFixed } from './modules/GnavFixed';
import { copyUrl } from './modules/CopyUrl';
import { toc } from './modules/Toc';
import { newsButton } from './modules/NewsButton';
import { accordion } from './modules/Accordion';
import { clickSearchformOpen } from './modules/ClickSearchformOpen';
import { fadeInUpFunc } from './modules/FadeInUpFunc';

window.addEventListener('load', () => {
  openingFunc();
  gnavFixed();
  smoothScroll();
});
popup();
newsButton();
drawer();
toc();
accordion();
copyUrl();
clickSearchformOpen();
fadeInUpFunc();
